module.exports = __webpack_public_path__ + "static/media/IMG_1262.da5a6341.jpg";